/**
 * 로컬 스토리지 서비스
 * prefix와 JSON 파싱을 적용하여 앱 전역에서 일관되게 사용합니다.
 */
class LocalStorageService {
    constructor() {
        Object.defineProperty(this, "STORAGE_KEY_PREFIX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'moda_localstorage_'
        });
    }
    setItem(key, value) {
        if (typeof window === 'undefined')
            return;
        localStorage.setItem(this.STORAGE_KEY_PREFIX + key, JSON.stringify(value));
    }
    getItem(key, includePrefix = true) {
        if (typeof window === 'undefined')
            return null;
        const fullKey = includePrefix ? this.STORAGE_KEY_PREFIX + key : key;
        const item = localStorage.getItem(fullKey);
        if (item === null)
            return null;
        try {
            return JSON.parse(item);
        }
        catch {
            return item;
        }
    }
    removeItem(key) {
        if (typeof window === 'undefined')
            return;
        localStorage.removeItem(this.STORAGE_KEY_PREFIX + key);
    }
    clearStorage() {
        if (typeof window === 'undefined')
            return;
        localStorage.clear();
    }
}
export const localStorageService = new LocalStorageService();
export default localStorageService;
//# sourceMappingURL=local-storage.service.js.map